// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"8":"b871b9fa","194":"0fb6a4d6","287":"de1123bb","405":"bfedeaec","408":"bfa77294","770":"6d6b58cc","797":"1fb02613","857":"0661b6e8","961":"6db8eafe"}[chunkId] + ".css";
};